import React from 'react';
import {WithTranslation} from 'react-i18next';
import {Image, View} from 'react-native';
import {noop} from 'lodash';

import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import ModalHeader from '/component/layout/ModalHeader';
import {withTranslation} from '/provider/TranslationProvider';
import {generateCallback} from '/util/component.util';
import {showComingSoonToast} from '/util/toast.util';

import {styles} from './Notifications.style';
import {getInboxAsset} from './Notifications.util';

// Define the types for props, extending WithTranslation
interface NotificationsProps extends WithTranslation {
  currentUserCompetency: string;
  onClose: () => void;
}

export class Notifications extends React.PureComponent<NotificationsProps> {
  static defaultProps = {
    currentUserCompetency: '',
    onClose: noop,
    tt: (_key: string, fallback: string) => fallback,
  };

  constructor(props: NotificationsProps) {
    super(props);
  }

  renderEmptyNotifications() {
    const {
      t: tt = (_key: string, fallback: string) => fallback,
      currentUserCompetency = '',
    } = this.props;

    return (
      <Gutter style={styles.emptyNotification}>
        <Image
          style={styles.inboxImage}
          source={getInboxAsset({currentUserCompetency})}
        />
        <Text style={styles.heading} variant="xLarge">
          {tt('empty.heading', 'All caught up')}
        </Text>
        <Text variant="small" style={styles.subheading}>
          {tt(
            'empty.subheading',
            "You don't have any notifications at the moment",
          )}
        </Text>
      </Gutter>
    );
  }

  override render() {
    const {
      t: tt = (_key: string, fallback: string) => fallback,
      onClose = () => {},
    } = this.props;
    return (
      <>
        <ModalHeader
          onClose={onClose}
          actionLabel={tt('clear', 'Clear All')}
          onActionPress={generateCallback({
            func: showComingSoonToast,
            params: 'clear-notifications',
          })}
          style={{base: styles.header}}>
          <Gutter>
            <Text variant="xLarge">{tt('header.text', 'Notifications')}</Text>
          </Gutter>
        </ModalHeader>
        <View style={styles.content}>{this.renderEmptyNotifications()}</View>
      </>
    );
  }
}

export default withTranslation('screen.notifications')(Notifications);
